import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { CustomPropType } from '../utils/propTypes';

const AuthProtected = (props) => {
    const authCtx = useAuth();
    const { isAuthenticated } = authCtx;
    if (!isAuthenticated) {
        return (
            <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
        );
    }

    return <>{props.children}</>;
}

AuthProtected.propTypes = CustomPropType;

export { AuthProtected };